module.exports = __webpack_public_path__ + "static/hero-wavy-c0104acbc5f8915402d6aa647c59aed2.png";